export default {
  // Navigation
  "nav.employees": "Työntekijät",
  "nav.departments": "Osastot",

  // Employees list
  "employees.title": "Työntekijät",
  "employees.name": "Nimi",
  "employees.work_email": "Työsähköposti",
  "employees.work_phone": "Työpuhelin",
  "employees.work_mobile": "Työmobiili",
  "employees.department": "Osasto",
  "employees.job_title": "Tehtävänimike",
  "employees.manager": "Esimies",
  "employees.state": "Tila",
  "employees.select_tenant": "Valitse ensin yritys.",
  "employees.delete_confirm": "Haluatko varmasti poistaa tämän työntekijän?",
  "employees.created": "Työntekijä luotu onnistuneesti",
  "employees.updated": "Työntekijä päivitetty onnistuneesti",

  // Employee form sections
  "employees.section.work": "Työtiedot",
  "employees.section.personal": "Henkilötiedot",
  "employees.section.emergency": "Hätäyhteyshenkilö",
  "employees.section.address": "Yksityinen osoite",

  // Employee form validation
  "employees.error.name_required": "Nimi on pakollinen",

  // User account
  "employees.user": "Käyttäjätili",

  // Employee form fields
  "employees.private_email": "Yksityinen sähköposti",
  "employees.private_phone": "Yksityinen puhelin",
  "employees.birthday": "Syntymäpäivä",
  "employees.gender": "Sukupuoli",
  "employees.nationality": "Kansalaisuus",
  "employees.identification_no": "Henkilötunnus",
  "employees.bank_account": "Pankkitili",
  "employees.emergency_contact_name": "Hätäyhteyshenkilön nimi",
  "employees.emergency_contact_phone": "Hätäyhteyshenkilön puhelin",
  "employees.private_street": "Katuosoite",
  "employees.private_city": "Kaupunki",
  "employees.private_zip": "Postinumero",
  "employees.private_country": "Maa",

  // Departments
  "departments.title": "Osastot",
  "departments.name": "Nimi",
  "departments.parent": "Yläosasto",
  "departments.manager": "Esimies",
  "departments.state": "Tila",
  "departments.select_tenant": "Valitse ensin yritys.",
  "departments.delete_confirm": "Haluatko varmasti poistaa tämän osaston?",
  "departments.error.name_required": "Nimi on pakollinen",
  "departments.created": "Osasto luotu onnistuneesti",
  "departments.updated": "Osasto päivitetty onnistuneesti",
};
